import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { of } from "rxjs";
import { FeeScheduleStore } from "../../store/fee-schedule/fee-schedule.store";

export const feeScheduleProviderIdResolver: ResolveFn<any> = (route) => {
    const feeScheduleStore = inject(FeeScheduleStore)
    feeScheduleStore.setActiveProviderId(Number(route.params['provider_id']))
    return of(true)
}